import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import OnboardingFlowCustomerSupportBannerMessage from 'src/components/OnboardingFlowCustomerSupportBannerMessage/OnboardingFlowCustomerSupportBannerMessage'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

const OnboardingFlowOrgInviteErrorBanner: React.FC = () => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        background-color: ${styleConstants.colors.red_darker};
        width: 100%;
        margin-bottom: 20px;
        border-radius: 6px;
        text-align: center;
        ${getFontCss(
          12,
          styleConstants.colors.red_darkest,
          styleConstants.fontFamilies.regular,
        )};
        z-index: 1;
      `}
    >
      <div>
        {translate(
          'Oops! There was a problem with the org invitation. Please contact your card program administrator to send another invite.',
        )}
      </div>
      <div>
        <OnboardingFlowCustomerSupportBannerMessage
          linkProps={{
            color: styleConstants.colors.red_darkest,
            hoverColor: styleConstants.colors.red_darkest,
          }}
        />
      </div>
    </div>
  )
}

export default OnboardingFlowOrgInviteErrorBanner
